/**
 * Create the store with dynamic reducers
 */

import { composeWithDevToolsDevelopmentOnly } from '@redux-devtools/extension';
import { routerMiddleware } from 'connected-react-router';
import { applyMiddleware, compose, createStore } from 'redux';
import { persistStore } from 'redux-persist';
import createSagaMiddleware from 'redux-saga';

import createReducer from './reducers';

const reduxDevToolsOptions = {
  name: 'Search V2',
  trace: true,
  // update_checkout_timer fires twice a second in dev, so clogs up the logs
  // rehydrate fires when the app is opened with ~10MB of data, causing dev tools to slow down
  actionsDenylist: ['data/UPDATE_CHECKOUT_TIMER', 'persist/REHYDRATE'],
};

export default function configureStore(initialState = {}, history) {
  let composeEnhancers = compose;

  // Set up Redux Dev Tools in dev env
  /* istanbul ignore next */
  composeEnhancers = composeWithDevToolsDevelopmentOnly(reduxDevToolsOptions);

  const sagaMiddleware = createSagaMiddleware({});

  // Create the store with two middlewares
  // 1. sagaMiddleware: Makes redux-sagas work
  // 2. routerMiddleware: Syncs the location/URL path to the state
  const middlewares = [sagaMiddleware, routerMiddleware(history)];

  const enhancers = [applyMiddleware(...middlewares)];

  const store = createStore(
    createReducer(),
    initialState,
    composeEnhancers(...enhancers),
  );

  const persistor = persistStore(store);

  // Extensions
  store.runSaga = sagaMiddleware.run;
  store.injectedReducers = {}; // Reducer registry
  store.injectedSagas = {}; // Saga registry

  // Make reducers hot reloadable, see http://mxs.is/googmo
  /* istanbul ignore next */
  if (module.hot) {
    module.hot.accept('./reducers', () => {
      store.replaceReducer(createReducer(store.injectedReducers));
    });
  }

  return { store, persistor };
}
